var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Vheader'),_c('main',{staticClass:"container-fluid"},[_c('contact'),_c('router-view')],1),_c('VFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }